<template>
   <load-form-handler
    :promise="getTabPromise"
    v-model="resource"
    placeholder
    error="handleErrorMessage">

    <h1 class="text-center">Estamos finalizando, agora precisamos de alguns documentos.</h1>
    <v-divider class="my-4 divider-accent" />

    <template v-for="(input, index) in file_inputs">
      <v-card :key="index+'-card'" class="mb-4">
        <v-flex pa-4>
          <v-layout column :key="index">
            <v-layout mb-4 column align-center>
              <template v-for="(title, index) in input.titles">
                <h2 :key="index" v-if="index === 0">{{ title }}</h2>
                <h3 :key="index" class="text-secondary" v-else>{{ title }}</h3>
              </template>
            </v-layout>
            <input-file
              :files="getDefaultFileBehaviour(resource[input.path_name])"
              @files="onFile"
              :filename="input.file_name"
              @error="onError"
              :multiple="input.is_multiple"/>
          </v-layout>
        </v-flex>
      </v-card>
    </template>

   </load-form-handler>
</template>

<script>
import InputFile from '@/components/InputFile'
import LoadFormHandler from '@/components/LoadFormHandler'
import * as api from '@/api'
import { message, formTabs } from '@/mixins'

/**
 * @group Form
 * Componente de form responável pelos documentos do estudante
 */
export default {
  name: 'FormStudentDocument',

  components: {
    InputFile,
    LoadFormHandler
  },

  data: () => ({
    resource: {},
    isFormLoading: true,
    emptyRule: [v => !!v || 'Campo obrigatório/Field is required'],
    file_inputs: [
      {
        titles: ['Carteira de vacinação', 'Vaccination card'],
        path_name: 'vaccination_card_path',
        file_name: 'vaccination_card',
        is_multiple: false
      },
      {
        titles: ['Certidão de nascimento', 'Birth certificate'],
        path_name: 'birth_certificate_path',
        file_name: 'birth_certificate',
        is_multiple: false
      },
      {
        titles: ['Receita Médica Anual - Para casos de febre/dor', 'Annual Medical Prescription - For cases of fever/pain'],
        path_name: 'book_purchase_proof_path',
        file_name: 'book_purchase_proof',
        is_multiple: false
      },
      {
        titles: ['Documento do(a) aluno(a) (RG/CPF)', 'Student Document (ID/CPF)'],
        path_name: 'signed_contract_path',
        file_name: 'signed_contract',
        is_multiple: false
      },
      {
        titles: ['Documento do Responsável 1 (RG/CNH)', 'Responsible 1 Document (RG/CNH)'],
        path_name: 'parents_documents_path',
        file_name: 'parents_documents',
        is_multiple: false
      },
      {
        titles: ['Documento do Responsável 2 (RG/CNH)', 'Responsible 2 Document (RG/CNH)'],
        path_name: 'parents_documents_2_path',
        file_name: 'parents_documents_2',
        is_multiple: false
      },
    ]
  }),

  mixins: [formTabs, message],

  methods: {
    getTabPromise () {
      return api.forms.documentation.get(this.currentStudentId)
    },

    /**
     * @vuese
     * Método para receimento de arquivos
     *
     */
    onFile ({ filename, files, multiple }) {
      let _files = {}

      if (!multiple) _files[filename] = this.prepareFileObjectStructure(files)
      else _files = files

      api.forms.documentation.update(this.currentStudentId, _files).then(({ data }) => {
        this.resource = data
        this.showMessageByType(this.messageTypes.FILE)
      }).catch(this.handleErrorMessage)
    },

    /**
     * @vuese
     * Método generico para tratamento de erros
     *
     * @arg
     * from Nome de origem da input
     * error Mensagem de erro
     */
    onError (error) {
      this.showMessage(error)
    },

    prepareFileObjectStructure (files) {
      return Array.isArray(files) ? files[0] : files
    },

    getDefaultFileBehaviour (files) {
      if (!files) return []

      if (!Array.isArray(files)) return [files]
      else return files
    }
  }
}
</script>

<style lang="stylus" scoped>
.text-truncate {
  flex 1
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
}
</style>
